
export const api = {
    host:  process.env.REACT_APP_API_URL,
    login: 'api/v1/auth/login',
    auth2faVerify: 'api/v1/auth/2fa/verify',
    loginWH: 'api/v1/auth/login-via-code',
    registration: 'api/v1/auth/register',
    invitationCode: 'api/v1/invitation',
    logout: 'api/v1/logout',
    resendEmail: 'api/v1/auth/email/resend',
    forgotPassword: 'api/v1/auth/password/forgot',
    resetPassword: 'api/v1/auth/password/reset',
    cabinet: {
        userData: 'api/v1/user',
        logout: 'api/v1/user/logout',
        wallets: 'api/v1/wallets',
        getCurrency: 'api/v1/currencies',
        getReceiveAsset: 'api/v1/wallets/by-asset',
        sendFee: 'api/v1/wallets/transactions/fee-estimate',
        marketCharts: 'api/v1/market/charts',
        partnersMain: 'api/v1/user/referral-summary',
        partnersAll: 'api/v1/user/referrals',
        exchangePoints: 'api/v1/user/point-exchanges',
        partnersCard: 'api/v1/user/card',
        getSubscribe: 'api/v1/subscriptions',
        profilePersonalInfo: 'api/v1/user/profile',
        profileChangePassword: 'api/v1/user/password',
        get2faOptions: 'api/v1/user/2fa',
        set2faGoogleCode: 'api/v1/user/2fa/confirm',
        set2faSettings: 'api/v1/user/2fa/scopes',
        depositAll: 'api/v1/deposits',
        sendCrypto: 'api/v1/wallets/transactions',
        openDeposit: 'api/v1/user/deposits',
        avatar: 'api/v1/user/avatar',
        partnersConvertHistory: 'api/v1/user/point-exchanges',
        hideBalance: 'api/v1/user/settings',
    }
}